/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data:{
        locked:false,
        voteLocked:false,
        post_id:qk_global.post_id,
        like:0,
        is_like:false
    },
    async mounted(){
        
    },
    methods:{
        collect(e){ 
            if(!qktoken) return this.$createModal('login');
            if(this.locked == true) return;
            
            this.locked = true
            
            this.$http.post(qk_rest_url+'userFavorites','&post_id='+this.post_id).then(res => {
                
                this.setNum(e,res.data.count);
                this.locked = false;
                this.$message({ message: res.data.message , type: 'success' });
                
            }).catch(err => {
                this.locked = false
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
        vote(type,e) {
            if(!qktoken) return this.$createModal('login');
            
            if(this.voteLocked == true) return;
            this.voteLocked = true;
            
            //let e = event;
            this.$http.post(qk_rest_url+'postVote','type='+type+'&post_id='+this.post_id).then(res=>{
                this.setNum(e,res.data.like);
                this.voteLocked = false;
                this.$message({ message: res.data.message , type: 'success' });
            }).catch(err => {
                this.voteLocked = false;
                this.$message({ message: qkGetApiError(err, '评论失败') , type: 'error' });
            })
        },
        goComment() {
            this.$scrollTo('#comments', 300, {offset: -85})
        },
        setNum(e,num){
            if(e.target.tagName != 'DIV'){
                e = e.target.parentNode.parentNode;
            }else{
                e = e.target.parentNode;
            }
            
            if(e.classList.contains('active')){
                e.classList.remove("active");
            }else{
                e.classList.add("active");
                
            }
            
            e.setAttribute('num',num)
        },
        report(){ 
            if(!qktoken) return this.$createModal('login');
            this.$createModal("report",{
                //keepAlive:false,
                props:{
                    post_id:this.post_id
                }
            })
        },
    }
};
